export const selectUserRoleIsPublisher = (state) => {
  return state?.manageApps?.user?.isPublisher;
};

export const selectFormNewApp = (state) => {
  return state?.manageApps?.form_new_app;
};
